import React from 'react';
import { DownloadIcon, PrinterIcon } from 'lucide-react';
import { toast } from 'sonner';
import { Modal } from '../shared/Modal';
import { DocHeader } from '../print/DocHeader';
import { bn, fmtDateTime, nowIso } from '../../utils/bn';
interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  columns: string[];
  rows: (string | number)[][];
}

/** Printable PDF / Excel export preview for any tabular report. */
export function ExportPreview({
  open,
  onClose,
  title,
  columns,
  rows
}: Props) {
  return <Modal open={open} onClose={onClose} title={`রপ্তানি প্রিভিউ — ${title}`} size="xl" footer={<>
        <button className="btn btn-outline" onClick={() => toast.success('Excel ফাইল প্রস্তুত (সিমুলেটেড ডাউনলোড)।')} data-id="element-68" data-mp="3bezxuvtsu2gm"><DownloadIcon className="h-4 w-4" data-id="element-69" data-mp="36ldwhzt35l04" /> Excel</button>
        <button className="btn btn-primary" onClick={() => window.print()} data-id="element-70" data-mp="2iwci7vxknfmx"><PrinterIcon className="h-4 w-4" data-id="element-71" data-mp="2dy177hvjiz34" /> PDF / প্রিন্ট</button>
      </>} data-id="element-67" data-mp="2wpu59qpgvahp">
      <div className="print-area bg-white p-6 border border-line" data-id="element-72" data-mp="2dvx7lc4ocm8n">
        <DocHeader office="ডিএমপি সদর দপ্তর — ট্রাফিক বিভাগ" title={title} data-id="element-73" data-mp="2kwybccfkhtpd" />
        <p className="mb-3 text-xs text-ink-muted" data-id="element-74" data-mp="2pwb052q01aul">প্রস্তুতের সময়: {fmtDateTime(nowIso())} · মোট রেকর্ড: {bn(rows.length)}</p>
        <div className="overflow-x-auto" data-id="element-75" data-mp="2uou9fnhnljtl">
          <table className="w-full border-collapse text-xs" data-id="element-76" data-mp="2yp4rhyiq00ot">
            <thead data-id="element-77" data-mp="2yommodhzse5a"><tr data-id="element-78" data-mp="2yocuqkddzwwy">{columns.map(c => <th key={c} className="border border-ink/30 bg-canvas px-2 py-1.5 text-left font-semibold" data-id="element-79" data-mp="2yqyzydct20c0">{c}</th>)}</tr></thead>
            <tbody data-id="element-80" data-mp="26xgh3hji5o8m">
              {rows.map((r, i) => <tr key={i} data-id="element-81" data-mp="2702nveykjzps" data-mpi={i}>{r.map((v, j) => <td key={j} className="border border-ink/20 px-2 py-1.5" data-id="element-82" data-mp="2aztmg4uc7k4v" data-mpi={j}>{typeof v === 'number' ? bn(v) : v}</td>)}</tr>)}
            </tbody>
          </table>
        </div>
        <p className="mt-4 text-[10px] text-ink-soft" data-id="element-83" data-mp="2fwac53h6q6k2">প্রোটোটাইপ প্রতিবেদন — নমুনা তথ্য</p>
      </div>
    </Modal>;
}